import { useViewer } from "@/authentication/ViewerProvider"
import Container from "@/components/ui/container"
import { H1 } from "@/components/ui/headings"
import Panel from "@/components/ui/panel"
import { MainLayout } from "@/novus/layouts/MainLayout"
import { Avatar } from "@/novus/components/avatar"
import React from "react"
import UpdatePasswordForm from "./components/UpdatePasswordForm"

const UpdatePasswordScreen = () => {
  const { viewer } = useViewer()

  return (
    <MainLayout>
      <Container>
        <H1>Update Password</H1>
        <Panel>
          <div className="flex flex-col items-center mb-10">
            <Avatar viewer={viewer} size="lg" />
          </div>
          <UpdatePasswordForm />
        </Panel>
      </Container>
    </MainLayout>
  )
}

export default UpdatePasswordScreen
